const sendAllToAccounting = `sendAllToAccounting`;

export default sendAllToAccounting;
